import React, { PropTypes } from 'react';
import Select from 'react-select';
import { selectify } from '../../businessLogic/util';
import { difference } from 'lodash';

export default class PreDefinedLocal extends React.Component {

	constructor(props) {
		super(props);
		this.state = { hasDrawnShapes: false, hasDrawnLocalities: false, hasDrawnSamplingPoints: false };
	}	

	componentDidUpdate(prevProps) {
		const { onAdd, sectors, localities, samplingPoints, shapes, mapLoaded } = this.props;
		const { hasDrawnLocalities, hasDrawnShapes, hasDrawnSamplingPoints } = this.state;
		if ( mapLoaded && shapes.sectors.length > 0 && sectors.length > 0 && !hasDrawnShapes) {
			onAdd(sectors);
			this.setState({hasDrawnShapes: true});
		}
		if ( mapLoaded && shapes.localities.length > 0 && localities.length > 0 && !hasDrawnLocalities) {
			onAdd(localities);
			this.setState({hasDrawnLocalities: true});
		}
		if ( mapLoaded && shapes.samplingPoints.length > 0 && samplingPoints.length > 0 && !hasDrawnSamplingPoints) {
			onAdd(samplingPoints);
			this.setState({hasDrawnSamplingPoints: true});
		}
	}

	render () {				
		const { setSectors, setLocalities, setSamplingPoints, sectors, 
			localities, samplingPoints, shapes, onRemove, onAdd } = this.props;

		return (	
			<div>		
				<div className="form-group">
					<label>Setor</label>
					<Select
						name="sectors-select"
						multi								
						value={sectors}							
						options={selectify(shapes.sectors)}									
						noResultsText="Nenhum resultado encontrado"
						placeholder="Selecione..."
						clearable={false}
						onChange={(value) => {						
							setSectors(value);
							if ( value.length < sectors.length ) onRemove(difference(sectors, value));
							else onAdd(difference(value, sectors));
						}}
					/>							
				</div>				
				<div className="form-group">
					<label>Localidade</label>
					<Select
						name="localities-select"
						multi								
						value={localities}							
						options={selectify(shapes.localities)}								
						noResultsText="Nenhum resultado encontrado"
						placeholder="Selecione..."
						clearable={false}
						onChange={(value) => {						
							setLocalities(value);
							if ( value.length < localities.length ) onRemove(difference(localities, value));
							else onAdd(difference(value, localities));
						}}
					/>							
				</div>				
				<div className="form-group">
					<label>Pontos de Amostragem</label>
					<Select
						name="points-select"
						multi								
						value={samplingPoints}							
						options={selectify(shapes.samplingPoints)}								
						noResultsText="Nenhum resultado encontrado"
						placeholder="Selecione..."
						clearable={false}
						onChange={(value) => {						
							setSamplingPoints(value);
							if ( value.length < samplingPoints.length ) onRemove(difference(samplingPoints, value));
							else onAdd(difference(value, samplingPoints));
						}}
					/>
				</div>
			</div>
		);
	}
}

PreDefinedLocal.propTypes = {
	mapLoaded: PropTypes.bool.isRequired,
	shapes: PropTypes.object.isRequired,
	onRemove: PropTypes.func.isRequired,
	onAdd: PropTypes.func.isRequired,
	setSectors: PropTypes.func.isRequired,
	setLocalities: PropTypes.func.isRequired,
	setSamplingPoints: PropTypes.func.isRequired,
	sectors: PropTypes.array.isRequired,
	localities: PropTypes.array.isRequired,
	samplingPoints: PropTypes.array.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Documents/PreDefinedLocal.js